<template>
  <DeadlineBadge
    :key="locale"
    :style="{
      'margin-left': color === 'FFFFFF00' ? 0 : '7px',
    }"
    :deadline="deadline"
    :color="color"
    :date-format="LISA_DATE_SHORT"
  />
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import { computed, type PropType } from "vue";
import type { ActionListActionFieldsFragment } from "@/graphql";
import DeadlineBadge from "../../badges/DeadlineBadge.vue";
import { LISA_DATE_SHORT } from "@/language/translation";
import getBadgeColor from "@/functions/badgeColor";

const props = defineProps({
  action: {
    type: Object as PropType<ActionListActionFieldsFragment>,
    required: true,
  },
});
const deadline = computed(() => props.action.deadline);
const color = computed(() => {
  return getBadgeColor(props.action.status, props.action.deadline);
});

const { locale } = useTranslation();
</script>

<style lang="scss" scoped></style>
